import './scss/style.scss';

import './js/parallax.min'
import './js/owl.carousel'

(function($) {
    $('.parallax-window').parallax()

    $('#owl-slider').owlCarousel({
        itemsCustom: [
            [0, 1],
            [600, 2],
            [900, 3],
        ],
        navigation: true,
        //autoPlay: 3000,
    });


    $('.scroll-to-anchor').on('click', function() {
        const $this = $(this);

        $('html, body').animate({
            scrollTop: $(this.hash).offset().top - 1
        }, 1000);

        const $messageField = $('#message');
        let message = $this.data('message');
        if (message && $messageField.val() == '') {
            $messageField.val(message);
        }
        
        return false;
    });


    const $contactWrapper = $('#kontakt');
    const $messageEl = $('.contact-form-message', $contactWrapper)
    $('#cform').on('submit', function(e) {
        e.preventDefault();
        const $form = $(this);
        
        $form.addClass('sending');
        $contactWrapper.removeClass('error');
        $messageEl.removeClass('success');
        $messageEl.removeClass('error');
        $.post('/contact.php', $form.serialize())
            .done(function(response) {
                $messageEl.html('<p>Tack för ditt meddelande! Vi hör av oss så fort som möjligt.</p>');
                $contactWrapper.addClass('sent');
                $messageEl.addClass('success');
                $form.slideUp(1000)
            })
            .fail(function(xhr, status, error) {
                $contactWrapper.removeClass('sending');
                $contactWrapper.addClass('error');

                $messageEl.addClass('error');

                if (xhr.responseText == 'fields') {
                    $messageEl.html('<p>Fälten är inte korrekt ifyllda</p>');
                } else {
                    $messageEl.html('<p>Något blev fel, försök igen annars ring oss på <a href="tel:0723201210">0723 - 20 12 10</a> eller skriv till <a href="mailto:info@mhkyl.se">info@mhkyl.se</a></p>');
                }
            });

        return false;
    });
}(jQuery));


